import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import SectionTitle from 'components/section-title'
import SectionEmptyState from 'components/section-empty-state'
import { DateTime } from 'luxon'
import CalendarTodayOutlinedIcon from 'components/material-symbol/icons/CalendarToday'
import { ScheduleListSkeleton } from './loading-skeleton'
import BookingActionButton from '../manage-business/booking-action-button'
import ScheduleRow from './schedule-row'
import useStyles from './styles'

const getUpNextKey = bookings => {
  const now = DateTime.now()
  const active = bookings.filter(booking => !booking.isCanceled)
  const currentOrUpcoming = active.find(booking => {
    const end = DateTime.fromISO(booking.endDateTime).setZone(booking.timezone)
    return end > now
  })

  return currentOrUpcoming
    ? `${currentOrUpcoming.id}-${currentOrUpcoming.startDateTime}`
    : null
}

const TodaysScheduleEmptyState = ({ hasOffering }) => {
  const classes = useStyles()

  return (
    <Box className={classes.emptyState}>
      <SectionEmptyState
        compact
        bordered={false}
        Icon={CalendarTodayOutlinedIcon}
        title="No sessions today"
        caption="Bookings you add will show up here."
        action={
          <BookingActionButton
            formLabel="dashboard-todays-schedule"
            hasOffering={hasOffering}
          />
        }
      />
    </Box>
  )
}

const TodaysSchedule = ({
  schedule,
  loading,
  hasOffering,
  onReschedule,
  onPayment,
  onCancellation,
}) => {
  const classes = useStyles()
  const today = DateTime.now()
  const activeSchedule = schedule.filter(booking => !booking.isCanceled)
  const sessionCount = activeSchedule.length
  const upNextKey = getUpNextKey(schedule)
  const subtitle = `${today.toFormat(
    'cccc, LLLL d',
  )} · ${sessionCount} session${sessionCount === 1 ? '' : 's'}`

  const listContent = (() => {
    if (loading) {
      return <ScheduleListSkeleton />
    }

    if (activeSchedule.length > 0) {
      return (
        <Box className={classes.list}>
          {activeSchedule.map(booking => (
            <ScheduleRow
              key={`${booking.id}-${booking.startDateTime}`}
              booking={booking}
              isUpNext={`${booking.id}-${booking.startDateTime}` === upNextKey}
              onReschedule={onReschedule}
              onPayment={onPayment}
              onCancellation={onCancellation}
            />
          ))}
        </Box>
      )
    }

    return <TodaysScheduleEmptyState hasOffering={hasOffering} />
  })()

  return (
    <Box className={classes.card}>
      <Box className={classes.header}>
        <Box>
          <SectionTitle size="card" className={classes.title}>
            Today&apos;s schedule
          </SectionTitle>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </Box>
      </Box>

      {listContent}
    </Box>
  )
}

export default TodaysSchedule
